export default __webpack_public_path__ + "static/media/428e183b01b85e31ca076d25a20f7bd7.svg";